import {TFunction} from "i18next";
import {Button} from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";

const ActionButtons = ({
                           handleClose,
                           t,
                           actionType = "submit",
                           actionButtonLabel = "submit",
                           onClick,
                           loading = false,
                           disabled = false,
                           noCancelButton = false
                       }: {
    handleClose: (key: any) => void,
    t: TFunction,
    actionType?: string;
    actionButtonLabel?: string;
    onClick?: () => void,
    loading: boolean,
    disabled?: boolean,
    noCancelButton?: boolean
}) => {
    return <>
        {!noCancelButton &&
            <Button variant="contained" disabled={loading} onClick={handleClose}>{t('global:cancel')}</Button>}
        <LoadingButton
            onClick={onClick}
            variant="contained"
            type={actionType}
            loading={loading}
            disabled={disabled}
        >
            {actionButtonLabel}
        </LoadingButton>
    </>
}

export default ActionButtons;